export default "__VITE_ASSET__wnVPxC0O__"